import { useAppSelector } from '../../../hooks/redux'
import { Colors } from '../../../constants/Colors'
import style from './PrevNext.module.css'
import PrevNextButton from './PrevNextButton'

interface Props {
    title: string,
    leftOnClick: () => void,
    leftDisabled: boolean,
    rightOnClick: () => void,
    rightDisabled: boolean
}

const PrevNextChanger = ({
        title,
        leftOnClick,
        leftDisabled,
        rightOnClick,
        rightDisabled
    }: Props
) => {

    const theme = useAppSelector<string>(state => state.theme.theme)

    return (
        <div
            className={style.container}
            style={{
                borderTop: `1px solid ${Colors[theme ?? 'light'].borderLighter}`,
                color: Colors[theme ?? 'light'].text,
                backgroundColor: Colors[theme ?? 'light'].secondBackground
            }}
        >
            <PrevNextButton
                icon={"fas fa-chevron-left"}
                disabled={leftDisabled}
                onClick={leftOnClick}
            />
            <div
                className={style.contentTitleContainer}
            >
                <span
                    className={style.contentTitle}
                >
                    {title}
                </span>
            </div>
            <PrevNextButton
                icon={"fas fa-chevron-right"}
                disabled={rightDisabled}
                onClick={rightOnClick}
            />
        </div>
    )
}

export default PrevNextChanger